import {Routes} from '@angular/router';
import {canActivateGuard} from '../../../guards/can-activate-guard';
import {PERMISSION} from '@generated-backend-types';
import {IndexComponent as PublicHolidayIndexComponent} from './index/index.component';

export const routes: Routes = [
  {
    path: '',
    component: PublicHolidayIndexComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.TIMETRACKING_PUBLICHOLIDAY_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.time_tracking.public_holidays.index.breadcrumb',
          translate: true,
          route: '/time-tracking/public-holidays',
        },
      ]
    }
  },
];
